<template>
    <div class="helpSec">
        <div>
            <HelpSidebar :propsSidebar="sidebar" :propsFirstContentNum="firstNumInfo" v-on:onChangeNum="changeNum"/>
        </div>
        <div>
            <HelpText :propsHelpContent="helpContent"/>
        </div>
    </div>
</template>
<script>
    import HelpSidebar from './content/HelpSidebar'
    import HelpText from './content/HelpText'

    export default {
        components: {
            HelpSidebar,
            HelpText,
        },
        props: {
            propsHelpParams: {
                type: Object,
                default: () => {
                    return {
                        lang: 'kr',
                        productCode: 'TIS50',
                        firstContentNum: '',
                        firstNumInfo: {}
                    }
                },
            },
        },
        watch: {
            propsHelpParams() {
                this.lang = this.propsHelpParams.lang;
                this.productCode = this.propsHelpParams.productCode;
                this.firstContentNum = this.propsHelpParams.firstContentNum;
                this.firstNumInfo = this.propsHelpParams.firstNumInfo;
                console.log(this.propsHelpParams.firstNumInfo)
                this.loadHelpSidebarList();
            },
        },
        data () {
            return {
                docsListPath: "/document/list",
                lang: '',
                productCode: '',
                firstContentNum: '',
                currentContentNum: '',
                sidebar: [],
                helpContent: {},
                firstNumInfo: {}
            }
        },
        methods: {
            changeNum(num) {
                this.currentContentNum = num;
                this.loadHelpText();
            },
            loadHelpText() {
                this.$http.get(this.docsListPath + "/contents", {params: {listNum : this.currentContentNum, lang : this.lang}}).then( res => {
                    if(res.data.documentContents != null) {
                        this.helpContent = res.data.documentContents;
                    } else {
                        alert("존재하지 않는 페이지 입니다.");
                        this.$router.go(-1);
                    }
                }).catch((error) => {
                    console.log(error);
                }).finally(() => {
                });
            },
            loadHelpSidebarList() {
                this.$http.get(this.docsListPath + "/sidebarlist", {params: {verCode : this.productCode, num : this.firstContentNum, lang : this.lang}}).then( res => {
                    this.sidebar = res.data.documentList;
                    if(res.data.documentList =! null && res.data.documentList.length > 0) {
                        this.changeNum(this.firstContentNum);
                        // this.sidebar.forEach((value) => {
                        //     if(this.num == value.num) {
                        //         value.selected = true;
                        //         value.childOpen = true;
                        //         return;
                        //     }
                        //     if(value.documentChildList) {
                        //         value.documentChildList.forEach((value2) => {
                        //             if(this.num == value2.num) {
                        //                 value2.selected = true;
                        //                 value.childOpen = true;
                        //                 value2.childOpen = true;
                        //                 return;
                        //             }
                        //             if(value2.documentChildList) {
                        //                 value2.documentChildList.forEach((value3) => {
                        //                     if(this.num == value3.num) {
                        //                         value3.selected = true;
                        //                         value.childOpen = true;
                        //                         value2.childOpen = true;
                        //                         value3.childOpen = true;
                        //                         return;
                        //                     }
                        //                 })
                        //             }
                        //         })
                        //     }
                        // });
                    } else {
                        alert("존재하지 않는 페이지 입니다.");
                        this.$router.go(-1);
                    }
                }).catch((error) => {
                    console.log(error);
                }).finally(() => {
                    // console.log("finally");
                })
            }
        }
    }
</script>